import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, FormStore, inject, TasksStore } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { AppStore } from '../Core/AppStore';
import { ActiveDisplay } from './ActiveDisplay';
import { DisplayFormDetails } from './DisplayFormDetails';
import { DisplayFormLocation } from './DisplayFormLocation';
import { DisplaysStore } from './DisplaysStore';

export interface IDisplayEditParams {
    serialNumber: string;
}

export interface IDisplayEditProps extends RouteComponentProps<IDisplayEditParams> {}

@autoinject
@observer
export class DisplayEdit extends React.Component<IDisplayEditProps> {
    public async componentDidMount() {
        await this.onLoad();
    }

    public render() {
        return (
            <div className="container-fluid pt-3">
                {this.updateDisplayStore && (
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <DisplayFormDetails updateDisplayStore={this.updateDisplayStore} />

                                        <DisplayFormLocation updateDisplayStore={this.updateDisplayStore} />

                                        <div className="col-12">
                                            <a className="btn btn-primary" onClick={this.updateDisplay}>
                                                Update
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    @bind
    @action
    private async onLoad() {
        try {
            await this.displaysStore.loadAsync(this.props.match.params.serialNumber, {
                params: {
                    status: true,
                },
            });
        } catch (e: any) {
            this.appStore.alertHandle.setError(e);
        }

        this.display = this.displaysStore.displays.get(this.props.match.params.serialNumber);

        if (this.display) {
            this.updateDisplayStore = new FormStore<Mri.Web.Portal.Controllers.Displays.UpdateDisplayModel>({
                customerDisplayID: this.display.displayConnectionData?.customerDisplayID ?? null,
                address1: this.display.unitLocation?.address1 ?? null,
                address2: this.display.unitLocation?.address2 ?? null,
                city: this.display.unitLocation?.city ?? null,
                country: this.display.unitLocation?.country ?? null,
                customerSiteID: this.display.unitLocation?.customerSiteID ?? null,
                description: this.display.unitLocation?.description ?? null,
                postalCode: this.display.unitLocation?.postalCode ?? null,
                stateOrProvince: this.display.unitLocation?.stateOrProvince ?? null,
                latitude: this.display.unitLocation ? (this.display.unitLocation.latitude as number | null) : 0,
                longitude: this.display.unitLocation ? (this.display.unitLocation.longitude as number | null) : 0,
            });
        }
    }

    @bind
    private async updateDisplay() {
        if (!this.updateDisplayStore || !this.display) {
            console.error('displayForm or display is not defined');
            this.appStore.setError(new Error('displayForm or display is not defined'));
            return;
        }

        this.updateDisplayStore.onSubmit();
        if (this.updateDisplayStore.validate()) {
            const task = this.tasksStore.startSessionTask(`Update Display ${this.display.serialNumber}`);

            try {
                await this.displaysStore.updateAsync(
                    this.props.match.params.serialNumber,
                    this.updateDisplayStore.values
                );

                task.complete();
            } catch (e: any) {
                if (e.modelState) {
                    this.updateDisplayStore.clearGlobalErrors();
                    this.updateDisplayStore.addErrors(e.modelState);
                }

                task.error(e);
            }
        } else {
            console.log('invalid');
        }
    }

    @observable
    private display?: ActiveDisplay;
    @observable
    private updateDisplayStore?: FormStore<Mri.Web.Portal.Controllers.Displays.UpdateDisplayModel>;
    @inject
    private appStore!: AppStore;
    @inject
    private displaysStore!: DisplaysStore;
    @inject
    private tasksStore!: TasksStore;
}
